/**
 * Shared helpers for the service-page per-block style map:
 * styles = { [blockId]: { desktop: StyleValue, mobile: StyleValue } }
 * StyleValue = { color, backgroundMode, backgroundColor, gradientFrom, gradientTo, gradientAngle, fontSize, fontWeight, textAlign }
 */

export function computeCssFromStyleValue(sv) {
  if (!sv) return {};
  const out = {};
  if (sv.color) out.color = sv.color;
  if (sv.backgroundMode === 'solid' && sv.backgroundColor) {
    out.background = sv.backgroundColor;
  } else if (sv.backgroundMode === 'gradient' && sv.gradientFrom && sv.gradientTo) {
    out.backgroundImage = `linear-gradient(${sv.gradientAngle ?? 135}deg, ${sv.gradientFrom}, ${sv.gradientTo})`;
  }
  if (sv.fontSize) out.fontSize = `${sv.fontSize}px`;
  if (sv.fontWeight) out.fontWeight = sv.fontWeight;
  if (sv.textAlign) out.textAlign = sv.textAlign;
  return out;
}

const CSS_PROP_NAMES = {
  color: 'color',
  background: 'background',
  backgroundImage: 'background-image',
  fontSize: 'font-size',
  fontWeight: 'font-weight',
  textAlign: 'text-align',
};

/** Builds `@media (max-width: bp) { [data-block-id="x"] { ... !important } }` for every block with mobile overrides. */
export function buildMobileStyleSheet(stylesMap, breakpoint = 640) {
  if (!stylesMap || typeof stylesMap !== 'object') return '';
  const rules = Object.entries(stylesMap)
    .map(([blockId, blockStyles]) => {
      const css = computeCssFromStyleValue(blockStyles?.mobile);
      const decls = Object.entries(css)
        .map(([prop, val]) => `${CSS_PROP_NAMES[prop] || prop}: ${val} !important;`)
        .join(' ');
      if (!decls) return '';
      return `[data-block-id="${blockId}"] { ${decls} }`;
    })
    .filter(Boolean)
    .join('\n');
  if (!rules) return '';
  return `@media (max-width: ${breakpoint}px) {\n${rules}\n}`;
}

export function getBlockStyle(stylesMap, blockId) {
  return (stylesMap && stylesMap[blockId]) || { desktop: {}, mobile: {} };
}
